import { useTimeTableMonth } from '../state/storeTimeTable';


export const useGetMetaHijraLocale = () => {
  const {updateHijraLocale,HijraLocale,updateISActive,updateHijraLan,updateHijraCalenderType} = useTimeTableMonth();


  const getMetaHijraLocale = (meta) => {
    if ( meta[ 'meta-key' ] === 'hijralocale' && meta?.value && typeof meta?.value === 'string') {
        const converter = JSON.parse( meta?.value)
        
        // console.log( 'hijra',   converter  );
        updateISActive(  converter.isActive  );
        updateHijraLan(  converter.lan  );
        updateHijraCalenderType( converter.calenderType  );
        updateHijraLocale(  converter  );
    }
}

const liveUpdateHijraLocale = (data) =>{
    
    updateHijraLocale(  data  );


  }

return {getMetaHijraLocale,liveUpdateHijraLocale}
}